// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-i_fc","advertDetailContacts__header":"c-i_fe"};